import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import { RootState } from "@/store/store";
import {
    updateNewAppointment,
    updateExistAppointment,
} from "@/store/appointments/appointmentsSlice";
import SkeletonList from "../../SkeletonList/SkeletonList";
import useSearch from "@/hooks/useSearch";

import { ISearchDrawerProps } from "@/shared/interfaces/ui";

import "./AppointmentsDrayewExistEntity.scss";
import { setPatientDoctorSelectorInDrawer } from "@/store/ui/ui";

export default function AppointmentsDrayewExistEntity({
    toggleDrawer,
}: ISearchDrawerProps) {
    const [query, setQuery] = useState<string>("");
    const dispatch = useDispatch();
    const patientDoctorSelectorInDrawer = useSelector(
        (state: RootState) => state.ui.patientDoctorSelectorInDrawer,
    );
    const data = useSelector((state: RootState) => state.data.data);
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );
    const { isLoading } = useSearch(
        patientDoctorSelectorInDrawer === "patient"
            ? "patients/searchpatient"
            : "users/searchuser",
        query,
    );
    const isDoctor = patientDoctorSelectorInDrawer === "doctor";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(e.target.value);
    };

    return (
        <>
            <input
                className='input_search'
                type='text'
                value={query}
                onChange={handleChange}
                maxLength={50}
                placeholder={`Ведіть прізвище ${
                    patientDoctorSelectorInDrawer === "patient"
                        ? "пацієнта"
                        : "лікаря"
                } `}
            />
            {isLoading ? (
                <SkeletonList />
            ) : data.length === 0 ? (
                <p className='drawer_listing_empty'>Співпадінь не знайдено!</p>
            ) : (
                <ul className='drawer_listing_list'>
                    {data.map(item => (
                        <li
                            className='drawer_listing_item'
                            key={item._id}
                            id={item._id}
                            onClick={() => {
                                if (isEditAppointment) {
                                    const payload =
                                        patientDoctorSelectorInDrawer ===
                                        "patient"
                                            ? {
                                                  patientId: {
                                                      _id: item._id,
                                                      name: item.name,
                                                      primaryPhone:
                                                          item.primaryPhone ??
                                                          "",
                                                  },
                                              }
                                            : {
                                                  doctorId: {
                                                      _id: item._id,
                                                      name: item.name,
                                                  },
                                              };
                                    dispatch(updateExistAppointment(payload));
                                } else {
                                    const payload =
                                        patientDoctorSelectorInDrawer ===
                                        "patient"
                                            ? {
                                                  patientId: item._id,
                                                  patientName: item.name,
                                              }
                                            : {
                                                  doctorId: item._id,
                                                  doctorName: item.name,
                                              };
                                    dispatch(updateNewAppointment(payload));
                                }

                                toggleDrawer(false);

                                if (isDoctor) {
                                    dispatch(
                                        setPatientDoctorSelectorInDrawer(
                                            "patient",
                                        ),
                                    );
                                }
                            }}
                        >
                            {item.name}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
}
